export const GET_CHOROPLETH_DATA_REQUEST = 'GET_CHOROPLETH_DATA_REQUEST'
export const GET_CHOROPLETH_DATA_SUCCESS = 'GET_CHOROPLETH_DATA_SUCCESS'
export const GET_CHOROPLETH_DATA_ERROR = 'GET_CHOROPLETH_DATA_ERROR'

export const GET_PIE_CHART_DATA_REQUEST = 'GET_PIE_CHART_DATA_REQUEST'
export const GET_PIE_CHART_DATA_SUCCESS = 'GET_PIE_CHART_DATA_SUCCESS'
export const GET_PIE_CHART_DATA_ERROR = 'GET_PIE_CHART_DATA_ERROR'
